import { borderRadius, breakpoint, colors, fontFamily, fontSize, fontWeight, mediaQueryHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  heading: css({
    color: colors.white,
    fontWeight: fontWeight.bold,
    fontSize: 18,
    marginTop: 0,
    marginBottom: 16, // we dont have a spacing value for this
    display: 'block',
    [mediaQueryHelper(breakpoint.tablet)]: {
      color: colors.oxfordBlue,
      marginLeft: 0,
      marginRight: 0,
      display: 'block',
    },
  }),

  hyperlinkText: css({
    color: colors.cornflowerBlue,
    textDecoration: 'none',
  }),

  desktopHeading: css({
    display: 'none',
    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'block',
    },
  }),

  mobileHeading: css({
    display: 'block',
    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'none',
    },
  }),

  wrapper: css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    width: '100%',
    margin: '0 auto',

    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
    },
  }),

  container: css({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  }),

  filters: css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    [mediaQueryHelper(breakpoint.phone)]: {
      flexDirection: 'row',
    },
  }),

  action: css({
    display: 'flex',
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
    width: `calc(100% - ${spacing.large * 2}px)`,
    marginLeft: spacing.large,
    marginRight: spacing.large,
    [mediaQueryHelper(breakpoint.phone)]: {
      width: 'auto',
      marginLeft: 0,
      marginRight: 0,
    },
  }),

  mobileSearchButton: css({
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    fontWeight: fontWeight.medium,
    color: colors.scorpion,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    borderRadius: borderRadius.default,
    border: `1px solid ${colors.grayChateau}`,
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
    width: '100%',
    [mediaQueryHelper(breakpoint.phone)]: {
      display: 'none',
    },
  }),

  searchBadgeContainer: css({
    display: 'flex',
  }),

  searchCountBadge: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    color: colors.cornflowerBlue,
    backgroundColor: '#C1E0FC',
    borderRadius: '50%',
    marginRight: '10px',
  }),
}

export default styles
